<template>
  <div>
    <WidgetSlotContainer
      title="Nächste Einheiten"
      :link="{name:'training.sessions.create'}"
      icon="fas fa-calendar"
      link-icon="fas fa-calendar-plus"
    >
      <div v-if="sessions.length>0">
        <sc-sessions-small
          v-for="session in sessions"
          :key="session.id"
          :session-id="session.id"
          :session-title="session.title"
          :session-date="session.date"
          :team-id="session.teamId"
          :team-name="session.teamName"
          :emphasis-tags="session.tags.emphasized"
          :participated="session.playerReviews"
          :total-red="session.totalRed"
          :total-yellow="session.totalYellow"
          @remove="archiveTraining"
        />
      </div>
      <div
        v-if="sessions.length<=0"
        class="p-4"
      >
        Keine anstehenden Trainingseinheiten.
      </div>
    </WidgetSlotContainer>

    <WidgetSlotContainer
      v-if="prevSessions.length>0"
      title="Letzte Einheiten"
      icon="fas fa-calendar"
    >
      <div v-if="prevSessions.length>0">
        <sc-sessions-small
          v-for="session in prevSessions"
          :key="session.id"
          :session-id="session.id"
          :session-title="session.title"
          :session-date="session.date"
          :team-id="session.teamId"
          :team-name="session.teamName"
          :emphasis-tags="session.tags.emphasized"
          :participated="session.playerReviews"
          :total-red="session.totalRed"
          :total-yellow="session.totalYellow"
          @remove="archiveTraining"
        />
      </div>
    </WidgetSlotContainer>
  </div>
</template>

<script>
import apiService from '../api/apiService'
import WidgetSlotContainer from '@/components/WidgetSlotContainer'

export default {
    name: 'NextSessionsVue',
    components: { WidgetSlotContainer },
    data () {
        return {
            isBusy: true,
            sessions: [],
            prevSessions: []
        }
    },
    async mounted () {
        await this.load()
        this.isBusy = false
    },
    methods: {
        async archiveTraining (id) {
            console.log(id)
            this.isBusy = true
            await apiService.archiveTraining(id)
            await this.load()
            this.isBusy = false
        },

        async load () {
            const response = await apiService.getMyNextSessions()
            this.sessions = response.data

            const lastSessions = await apiService.getMyLastSessions()
            this.prevSessions = lastSessions.data
        }
    }

}
</script>

<style scoped>

</style>